import { useState } from 'react';

import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { SkcDeviceGroupDetailsContainer } from '~features/access';

import PageNotFoundPage from '../other/pageNotFoundPage';
import Page from '../page';

const SkcDeviceGroupDetailsPage = () => {
	const { t } = useTranslation();
	const { id } = useParams();

	if (!id) {
		return <PageNotFoundPage />;
	}

	return (
		<Page title={`${t('deviceGroupDetails')} ${id}`}>
			<SkcDeviceGroupDetailsContainer id={id} />
		</Page>
	);
};

export default SkcDeviceGroupDetailsPage;
